"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var modifierCustom_1 = require("./modifiers/modifierCustom");
var modifierMaximumLength_1 = require("./modifiers/modifierMaximumLength");
var modifierToLowerCase_1 = require("./modifiers/modifierToLowerCase");
var modifierToUpperCase_1 = require("./modifiers/modifierToUpperCase");
var modifierCapitalize_1 = require("./modifiers/modifierCapitalize");
var modifierToNumber_1 = require("./modifiers/modifierToNumber");
var modifierToKeepNumbers_1 = require("./modifiers/modifierToKeepNumbers");
var update = function (updateForm) { return function (liveModifiers) {
    if (liveModifiers === void 0) { liveModifiers = {}; }
    return function (event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (!((_a = event.target) === null || _a === void 0 ? void 0 : _a.name)) {
            throw new Error("Your request must have a name");
        }
        var value = (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value;
        switch (event.target.type) {
            case 'custom':
            case 'hidden':
            case 'password':
            case 'radio':
            case 'search':
            case 'select-one':
            case 'text':
            case 'textarea':
                ((typeof liveModifiers.custom === "function") && (value = modifierCustom_1.modifierCustom(value, liveModifiers.custom)));
                (!!liveModifiers.maximumLength && (value = modifierMaximumLength_1.modifierMaximumLength(value, liveModifiers.maximumLength)));
                (!!liveModifiers.toLowerCase && (value = modifierToLowerCase_1.modifierToLowerCase(value)));
                (!!liveModifiers.toUpperCase && (value = modifierToUpperCase_1.modifierToUpperCase(value)));
                (!!liveModifiers.toCapitalized && (value = modifierCapitalize_1.modifierCapitalize(value)));
                (!!liveModifiers.toNumber && (value = modifierToNumber_1.modifierToNumber(value)));
                (!!liveModifiers.toKeepNumbers && (value = modifierToKeepNumbers_1.modifierToKeepNumbers(value)));
                return updateForm({ key: (_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.name, value: value, actionType: "update" });
            case 'checkbox':
                return updateForm({ key: (_d = event.target) === null || _d === void 0 ? void 0 : _d.name, value: null, actionType: "updateCheckbox" });
            case 'email':
                return updateForm({ key: (_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.name, value: (_g = (_f = event === null || event === void 0 ? void 0 : event.target) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g.trim().toLowerCase(), actionType: "update" });
            case 'color':
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'number':
            case 'range':
            case 'tel':
            case 'time':
            case 'url':
            case 'week':
                return updateForm({ key: (_h = event === null || event === void 0 ? void 0 : event.target) === null || _h === void 0 ? void 0 : _h.name, value: (_j = event === null || event === void 0 ? void 0 : event.target) === null || _j === void 0 ? void 0 : _j.value, actionType: "update" });
            case 'file':
                return updateForm({ key: (_k = event === null || event === void 0 ? void 0 : event.target) === null || _k === void 0 ? void 0 : _k.name, value: (_l = event === null || event === void 0 ? void 0 : event.target) === null || _l === void 0 ? void 0 : _l.files, actionType: "update" });
            case 'button':
            case 'image':
            case 'reset':
            case 'submit':
            default:
                throw new Error("Unhandled type " + ((_m = event === null || event === void 0 ? void 0 : event.target) === null || _m === void 0 ? void 0 : _m.type));
        }
    };
}; };
exports.update = update;
//# sourceMappingURL=update.js.map